import css from './modals.module.scss'

import ApplicationController from './application_controller.js'
export default class ModalsController extends ApplicationController {

  static targets = ["header", "body", "content", "footer", "confirm", "dismiss"]

  static overlay = null
  static modals_el = []

  base_zindex = 500

  I18N = {
    confirm: 'Valider',
    ok: 'Ok',
    dismiss: 'Annuler'
  }

  TMPL = `
         <div data-target="modals.body" class="${css.body}">
            <div data-target="modals.header" class="${css.header}">
            </div>
            <hr class="header"/>
            <div data-target="modals.content" class="${css.content}">
            </div>
            <div data-target="modals.footer" class="${css.footer}">
              <hr/>
              <button data-target="modals.dismiss" data-reason="dismiss" class="${css.dismiss}"></button>
              <button data-target="modals.confirm" data-reason="confirm" class="${css.confirm}"></button>
            </div>
         </div>
        `

  connect() {
  }

  disconnect() {
  }

  modal(content, options = {}, callback) {
    options.content = content
    return this._modal(options, callback)
  }

  /*
   * options :
   * - header_text
   * - content
   * - confirm_text
   * - dismiss_text
   * - type : alert, confirm, modal
   * - caution: none, ask, danger
   * - size : small, large
   */

  _modal(options = {}, callback) {
    options.type = options.type || 'modal'
    options.caution = options.caution || 'none'
    options.size = options.size || 'small'
    options.confirm_text = options.confirm_text || this.I18N.confirm
    options.dismiss_text = options.dismiss_text || this.I18N.dismiss
    options.header_text = options.header_text || ''
    if (options.autoclose === undefined) options.autoclose = true
    this.options = options
    this.callback = callback

    var el = this._create_modal(options)
    ModalsController.modals_el.push(el)

    this.headerTarget.innerText = options.header_text
    this.dismissTarget.innerText = options.dismiss_text
    this.confirmTarget.innerText = options.confirm_text

    if (options.type == 'dialog' || options.type == 'alert') {
      this.dismissTarget.style.display = 'none'
    }

    if (options.type != 'modal') {
      this.contentTarget.style.textAlign = 'center'
      this.contentTarget.classList.add(css.nonModal)
    }

    if (options.header_text == '') {
      el.querySelector('hr.header').style.display = 'none'
    }

    if (ModalsController.modals_el.length == 1) {
      ModalsController.body_overlay = document.createElement('div')
      ModalsController.body_overlay.classList.add(css.bodyOverlay)
      document.body.appendChild(ModalsController.body_overlay)
      document.body.addEventListener('keyup', this.handle_events, false)
    }

    el.addEventListener('click', this.handle_events, false)
    this.modal_overlay.addEventListener('click', this.handle_events, false)
  }

  handle_events = (e) => {
    var modal_el = ModalsController.modals_el[ModalsController.modals_el.length - 1]

    if (e.type == 'click' && e.target === this.modal_overlay) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    var reason = {}
    if (e.type == 'click' && (e.target === this.confirmTarget || e.target === this.dismissTarget)) {
      reason[e.target.dataset.reason] = 'handled'
    }
    if (this.options.type != 'confirm' && (e.type == 'keyup' && e.key == 'Escape') /* || (e.type == 'click' && e.target === this.modal_overlay) */) {
      reason = { dismiss: 'handled' }
    }
    if (reason.confirm || reason.dismiss) {
      e.preventDefault()
      e.stopPropagation()

      var closer = () => {
        this.closed = true
        ModalsController.modals_el.pop()
        if (ModalsController.modals_el.length == 0) {
          document.body.removeChild(ModalsController.body_overlay)
          document.body.removeEventListener('keyup', this.handle_events, false)
        }
        document.body.removeChild(modal_el.parentNode)
      }

      if (modal_el.querySelector('form')) {
        reason['form'] = modal_el.querySelector('form')
      }
      if (this.callback) {
        reason.close_modal = closer
        this.callback(reason)
      } else
        closer()
    }
  }

  _create_modal(options) {
    var zindex = this.base_zindex + (ModalsController.modals_el.length * 5)

    var el = document.createElement('div')
    this.modal_overlay = document.createElement('div')
    this.element.appendChild(this.modal_overlay)
    this.element.appendChild(el)

    this.modal_overlay.classList.add(css.modalOverlay)
    this.modal_overlay.style.zIndex = zindex

    el.innerHTML = this.TMPL
    this.contentTarget.innerHTML = options.content
    el.classList.add(css.modal)
    el.style.zIndex = zindex + 1

    el.style.top = `${(ModalsController.modals_el.length * 10) + window.scrollY + 50}px`
    var width
    switch (options.size) {
      case 'small':
      default:
        width = window.innerWidth / 3
        break
      case 'large':
        width = window.innerWidth / 2
    }
    el.style.width = `${width}px`
    var left = window.innerWidth / 2 - (width / 2)
    el.style.left = `${left}px`
    return el
  }

}